export default __webpack_public_path__ + "static/media/spotbills-screenshots.824acc46.jpg";